import {confirmationActionTypes} from './../consts';

const defaultState = {};

const confirmation = (state = defaultState, action) => {
    if (action.type === confirmationActionTypes.open && !state.id) {
        return {id: action.payload.id, message: action.payload.message}
    } else if (action.type === confirmationActionTypes.close && state.id) {
        return {};
    } else {
        return state;
    }
};

export default confirmation;


// WEBPACK FOOTER //
// ./src/app/reducers/confirmation.js